export default function($compile) {
  'ngInject';

  /**
   * Configures a uib datepicker on an input element. Pass in the boolean prop for whether the datepicker is open.
   */
  return {
    priority: 1001,
    terminal: true,
    restrict: 'A',
    scope: false,
    link: (scope, element, attrs) => {
      const openProp = element.attr('pro-date-picker');

      // prevent the directive from being applied repeatedly
      element.removeAttr('pro-date-picker');

      element.attr(
        'alt-input-formats',
        "['M!-d!-yyyy', 'M!.d!.yyyy', 'M!/d!/yy', 'M!-d!-yy', 'M!.d!.yy', 'yyyy/M!/d!', 'yyyy-M!-d!', 'yyyy.M!.d!']"
      );
      element.attr('class', 'form-control');
      element.attr('close-text', 'Close');
      element.attr('is-open', openProp);
      element.attr('placeholder', 'mm/dd/yyyy');
      element.attr('type', 'text');
      element.attr('uib-datepicker-popup', 'M!/d!/yyyy');

      const openFunction = `${openProp} = !${openProp}`;
      const inputGroup = createInputGroup();
      const calendarButton = createCalendarButton(openFunction);
      const nextSibling = element[0].nextSibling;
      element[0].parentNode.insertBefore(inputGroup, nextSibling);
      inputGroup.appendChild(element[0]);
      inputGroup.appendChild(calendarButton);

      $compile(inputGroup)(scope);
    }
  };
}

/**
 * Creates the wrapper group
 */
const createInputGroup = () => {
  const ele = document.createElement('div');
  ele.setAttribute('class', 'input-group');

  return ele;
};

/**
 * Creates the calendar icon button that opens the date picker
 *
 * @param {*} openFunction
 */
const createCalendarButton = openFunction => {
  const calendarSpan = document.createElement('span');
  calendarSpan.setAttribute('class', 'input-group-addon');
  calendarSpan.setAttribute('ng-click', openFunction);

  const calendarIcon = document.createElement('i');
  calendarIcon.setAttribute('class', 'fa fa-calendar');

  calendarSpan.appendChild(calendarIcon);

  return calendarSpan;
};



// WEBPACK FOOTER //
// ./src/app/directives/proDatePicker/index.js